import React from 'react';
import styled from 'styled-components';
import {AccentColorOptions} from 'epic-ue-theme';
import {
    Button,
    CmsButtonProps,
    FeaturedCardCarousel,
    ImageCardList,
    ImageCardProps,
    VerticalSpacer
} from '..';

const FeedWrapper = styled.div`
    hr {
        margin: 48px;
    }

    .see-more-button-wrap {
        width: 100%;
        text-align: center;
    }
`;

const HorizontalRule = styled.hr`
    border-color: ${(p) => p.theme.palette.text.disabled};
    opacity: 0.2;
    margin: 4em 0;
`;

export interface FeedProps {
    accentColor?: AccentColorOptions;
    showCarousel?: boolean;
    cards?: ImageCardProps[];
    button?: CmsButtonProps;
}

export const Feed = ({
    accentColor = 'sky',
    showCarousel,
    cards = [],
    button
}: FeedProps): JSX.Element => {
    const featuredCardCarousel = showCarousel ? cards.slice(0, 3) : cards.slice(0, 1);

    //For totalCardsLessThan6, show grid of 3 instead of 4
    const totalCardsLessThan6 = cards.length < 6;

    const firstImageCardRow = (
        showCarousel
            ? cards.slice(3, totalCardsLessThan6 ? 6 : 7)
            : cards.slice(1, totalCardsLessThan6 ? 4 : 5)
    ).map((card) => {
        return {
            image: card.image,
            title: card.title,
            link: card.link
        };
    });
    const secondImageCardRow = (
        showCarousel
            ? cards.slice(totalCardsLessThan6 ? 6 : 7, totalCardsLessThan6 ? 9 : 11)
            : cards.slice(totalCardsLessThan6 ? 4 : 5, totalCardsLessThan6 ? 7 : 9)
    ).map((card) => {
        return {
            image: card.image,
            title: card.title,
            link: card.link
        };
    });

    return (
        <FeedWrapper>
            <FeaturedCardCarousel slides={featuredCardCarousel} accentColor={accentColor} />

            <VerticalSpacer variant="section" />
            <ImageCardList cards={firstImageCardRow} />
            <HorizontalRule />
            <ImageCardList cards={secondImageCardRow} />
            <VerticalSpacer variant="feature" />
            <div className="see-more-button-wrap">
                {button && button.label && (
                    <Button
                        type={button.type || 'secondary'}
                        href={button.href}
                        color={accentColor}>
                        {button.label}
                    </Button>
                )}
            </div>
        </FeedWrapper>
    );
};
